import { TABS } from './RecordPaymentPanel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecordPaymentTabs = ({
  selectedTab,
  setSelectedTab,
  shouldDisableTabs
}) => {
  return /*#__PURE__*/_jsxs(Tabs, {
    defaultSelected: selectedTab,
    onSelectedChange: setSelectedTab,
    use: "enclosed",
    marginBlock: "400",
    children: [/*#__PURE__*/_jsx(Tab, {
      tabId: TABS.ADD_NEW,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.modals.recordPaymentTabs.recordNew"
      }),
      disabled: shouldDisableTabs
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: TABS.ADD_EXISTING,
      "data-test-id": "record-existing-payment-tab",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.modals.recordPaymentTabs.applyExisting"
      }),
      disabled: shouldDisableTabs
    })]
  });
};
export default RecordPaymentTabs;